import { render, staticRenderFns } from "./KeycloakPage.vue?vue&type=template&id=4248ccb8"
import script from "./KeycloakPage.vue?vue&type=script&lang=js"
export * from "./KeycloakPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4248ccb8')) {
      api.createRecord('4248ccb8', component.options)
    } else {
      api.reload('4248ccb8', component.options)
    }
    module.hot.accept("./KeycloakPage.vue?vue&type=template&id=4248ccb8", function () {
      api.rerender('4248ccb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/KeycloakPage.vue"
export default component.exports